import "./addAssetConditionForm.scss";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import newRequest from "../../../utils/newRequest";
import CustomSnakebar from "../../../utils/CustomSnakebar";
import { useTranslation } from "react-i18next";

const UpdateEmployeeListForm = ({ inputs, title }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [rowData, setRowData] = useState({});
  const [formValues, setFormValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    newRequest
      .post("/GetEmployeeListById", { EmpID: id })
      .then((response) => {
        const record =
          response?.data?.recordset?.[0] ??
          response?.data?.recordsets?.[0]?.[0] ??
          {};
        setRowData(record);
        setFormValues({
          EmpID: record.EmpID ?? id ?? "",
          EmpName: record.EmpName ?? "",
          EmpRegion: record.EmpRegion ?? "",
          EmpUnit: record.EmpUnit ?? "",
          EmpDivision: record.EmpDivision ?? "",
        });
      })
      .catch((err) => {
        setError(err?.response?.data?.message ?? "Failed to load");
      });
  }, [id]);

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  const handleSubmit = async (event) => {
    if (!event.target.checkValidity()) return;
    event.preventDefault();
    setIsLoading(true);
    try {
      const data = {
        EmpID: formValues.EmpID ?? id,
        EmpName: formValues.EmpName,
        EmpRegion: formValues.EmpRegion,
        EmpUnit: formValues.EmpUnit,
        EmpDivision: formValues.EmpDivision,
      };
      await newRequest.put("/UpdateEmployeeListById", data);
      setMessage(t("Successfully Updated") || "Successfully Updated");
    } catch (err) {
      setError(err?.response?.data?.message ?? "Failed to Update");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event, inputName) => {
    setFormValues({ ...formValues, [inputName]: event.target.value });
  };

  return (
    <>
      {isLoading && (
        <div
          className="loading-spinner-background"
          style={{
            zIndex: 9999,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BeatLoader size={18} color="#6439ff" loading={isLoading} />
        </div>
      )}
      <span>
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <div className="assetCategoryForm">
          <div className="newContainer">
            <div className="top">
              <span className="topSpan">
                <h1>{title}</h1>
                <button type="button" onClick={() => navigate(-1)}>
                  {t("Go Back")}
                </button>
              </span>
            </div>
            <div className="bottom">
              <div className="right">
                <form onSubmit={handleSubmit} id="employeeListUpdateForm">
                  {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label htmlFor={input.name}>{input.label}</label>
                      <input
                        type={input.type || "text"}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        required={input.isFieldRequired}
                        value={formValues[input.name] ?? ""}
                        onChange={(e) => handleInputChange(e, input.name)}
                        readOnly={input.name === "EmpID"}
                      />
                    </div>
                  ))}
                  <div className="buttonAdd">
                    <button type="submit">
                      {t("Update")} {t("Employee")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    </>
  );
};

export default UpdateEmployeeListForm;

